import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  PlaceholderColumnas,
  PlaceholderTabla,
} from "../../components/Otros/Placeholder";
import { PendientesAutorizar } from "../../components/PreCalificacion/PendientesAutorizar";
import { InformacionProcesoParticipacion } from "../../components/ProcesosDeCalificacion/InformacionProcesoParticipacion";
import { cargarDatosProceso, cargarProcesoActivo } from "../../utils/Datos";

export const AdministracionMunicipalBandeja = () => {
  const [datosProceso, setDatosProceso] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);

  useEffect(() => {
    setCargandoDatos(true);
    cargarProcesoActivo().then((datos) => {
      console.log("///Datos: proceso ACtivo//");
      console.log(datos);
      cargarDatosProceso(datos.id_process).then((datosProceso) => {
        console.log("///Datos: proceso//");
        setDatosProceso(datosProceso);
        setCargandoDatos(false);
      });
    });
  }, []);

  return (
    <div className="post d-flex flex-column-fluid" id="kt_post">
      <div className="container-xxl">
        <div className="row gy-5 g-xl-8">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title align-items-start flex-column">
                  <span className="card-label fw-bolder text-dark">
                     INFORMACIÓN DEL PROCESO
                  </span>
                </h3>
              </div>
              <div className="card-body">
                {cargandoDatos === true || datosProceso == null ? (
                  <PlaceholderColumnas columnas={2}></PlaceholderColumnas>
                ) : (
                  <InformacionProcesoParticipacion
                    key="-editar_proceso"
                    proceso={datosProceso}
                  />
                )}
              </div>
            </div>
          </div>

          <div className="col-xl-12 ">
            <div className="card ">
              <div className="card-header ">
                <h3 className="card-title align-items-start flex-column ">
                  <span className="card-label fw-bolder text-dark ">
                     EVALUACIONES / PRECALIFICACIONES POR AUTORIZAR
                  </span>
                </h3>
              </div>
              <div className="card-body ">
                {cargandoDatos === true || datosProceso == null ? (
                  <PlaceholderTabla></PlaceholderTabla>
                ) : (
                  <PendientesAutorizar />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
